import { useTranslate } from "@refinedev/core";
import { Button, Flex, Modal } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const NoAnimationModal = ({ projectId }: { projectId: string }) => {
  const navigate = useNavigate();
  const t = useTranslate();

  const [modalOpened, setModalOpened] = useState<boolean>(true);
  return (
    <Modal
      title={t("components.binder.index.noDataModal.title")}
      open={modalOpened}
      closable={false}
      footer={null}
    >
      <Flex vertical gap={20}>
        {t("components.binder.index.noDataModal.message")}
        <Flex gap={10} justify="flex-end">
          <Button onClick={() => setModalOpened(false)}>
            {t("components.binder.index.noDataModal.confirm")}
          </Button>
          <Button
            type="primary"
            onClick={() => navigate(`/media/projects/${projectId}`)}
          >
            {t("components.binder.index.noDataModal.cancel")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
